export default class WeeklyLetter {

    constructor() {
        //console.log("weekly letter")
    }
}